import React from 'react'
import { join, filter, compose, map, isNil, complement } from 'ramda'
import momentTimezone from 'moment-timezone'

const PreviewEventDate = ({
  startDateTime,
  startTimezone,
  endDateTime,
  endTimezone,
}) => {
  const eventStartEnd = [
    { dateTime: startDateTime, timezone: startTimezone },
    { dateTime: endDateTime, timezone: endTimezone },
  ]

  const dates = compose(
    map((m) =>
      m.dateTime
        ? momentTimezone(m.dateTime)
            .tz(m.timezone)
            .format('ddd, DD MMM [at] h:mm A')
        : '',
    ),
    filter(complement(isNil)),
  )(eventStartEnd)

  return (
    <div className="mt-8 mx-16">
      <span className="text-14 text-orange-600">
        {join(' - ', dates)} (GMT{momentTimezone.tz(endTimezone).format('Z')})
      </span>
    </div>
  )
}

export default PreviewEventDate
